<template>
    <div>
        <a-t-list
            :modal-title="sellShow ? 'Venda' : 'Nova Venda'"
            name="Venda"
            plural-name="Vendas"
            fetch-url="sell"
            fetch-trashed-url="sell/trashed"
            save-url="sell"
            entity-search-url="client/search/"
            entity-name="Cliente"
            madeByLabel="Vendedor"
            :article-transaction-type="Global.ARTICLE_TRANSACTION_SELL"
            :has-discount="true"
        ></a-t-list>
    </div>
</template>

<script>
    import ATList from '../article_transaction/ATList';
    import {Global} from "../../config";

    export default {
        name: "Sells",
        data(){
            return {
                Global,
            }
        },

        components: {
            ATList,
        },

        methods: {

        },

        computed: {
            sellShow: {
                get(){
                    return this.$store.getters.getSellShow;
                },
                set(value){
                    this.$store.dispatch('setSellShow', value);
                }
            },

        }
    }
</script>

<style scoped>

</style>